/* eslint-disable @typescript-eslint/no-explicit-any */
import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import {
  RATES_DATA,
  RATES_DATA_FOR_SELECTED_PROPERTY,
  PROPERTY_INFO_DATA,
  SEARCH_RESULTS_ALERTS,
  SESSION_DATA_VALUES,
} from '../constants';
import { deepCloneZustandState } from '../utils/helpers';

export interface SearchResultsState {
  ratesData: any;
  ratesDataForSelectedProperty: any;
  propertyInfoData: any;
  searchResultsAlerts: any;
  sessionDataValues: any;
  setSearchResultsState: (fieldNamesArray: Array<string>, fieldsData: any, reset?: boolean) => any;
}

const initialState: SearchResultsState = {
  [RATES_DATA]: {
    [RATES_DATA]: {},
  },
  [RATES_DATA_FOR_SELECTED_PROPERTY]: {
    [RATES_DATA_FOR_SELECTED_PROPERTY]: {},
  },
  [PROPERTY_INFO_DATA]: {
    [PROPERTY_INFO_DATA]: {},
  },
  [SEARCH_RESULTS_ALERTS]: {
    [SEARCH_RESULTS_ALERTS]: {},
  },
  [SESSION_DATA_VALUES]: {
    [SESSION_DATA_VALUES]: {
      isFlexibleSearch: '',
      recentlyViewedPropertyCode: '',
    },
  },
  setSearchResultsState: () => {},
};

function searchResultsStateHelperFunction(
  state: Record<string, any>,
  fieldNames: Array<string>,
  fieldsData: Record<string, any>,
  reset?: boolean
): object {
  const updatedState = deepCloneZustandState(state);
  //to reset everything inside the given field , this will not reset the whole store but only reset the given fieldname
  if (reset) {
    fieldNames.forEach((name: string) => {
      updatedState[name] = {};
    });
  }
  fieldNames.forEach((name: string) => {
    updatedState[name] = { ...updatedState[name], ...fieldsData[name] };
  });
  return updatedState;
}

const SearchResultsStore: StateCreator<SearchResultsState> = set => {
  return {
    ...initialState,
    setSearchResultsState: (fieldNamesArray: Array<string>, fieldsData: any, reset?: boolean) =>
      set(state => {
        const updatedState = searchResultsStateHelperFunction(state, fieldNamesArray, fieldsData, reset);
        return updatedState;
      }),
  };
};

export const useSearchResultsStore = createAppStore(SearchResultsStore, {
  usePersistentStore: false,
});
